import { useEffect, useState } from 'react';
import { formattingNumber } from 'utils';
import { StyledBundlePrice } from './style';
import { Box } from '@mui/material';
import { Price, Gradient } from 'utils/types';
import { ActualPrice } from 'components/BundlePrice/ActualPrice';

export interface IBabaBundlePriceProps {
  price: Price;
  isPreview?: boolean;
  bundleButtonColor?: Gradient;
  bundleButtonTextColor?: string;
  isFree?: boolean;
  collectText?: string;
}

export const BabaBundlePrice: React.FC<IBabaBundlePriceProps> = ({
  price,
  isPreview = false,
  bundleButtonColor,
  bundleButtonTextColor = 'white',
  isFree = false,
  collectText = '',
}) => {
  const [finalPrice, setFinalPrice] = useState('');
  const [priceBeforeDiscount, setPriceBeforeDiscount] = useState('');

  useEffect(() => {
    if (isFree) return;

    const formattedPrice = formattingNumber(
      price.price,
      price,
      price.isCents,
      price.multiplier,
      !isPreview,
    );
    if (price.strokedPriceInCents) {
      const formattedPriceBeforeDiscount = formattingNumber(
        price?.strokedPriceInCents,
        price,
        price.isCents,
        price.multiplier,
        !isPreview,
      );
      setPriceBeforeDiscount(formattedPriceBeforeDiscount);
    }
    setFinalPrice(formattedPrice);
  }, [price, isPreview]);

  return (
    <StyledBundlePrice
      bundleButtonColor={bundleButtonColor}
      bundleButtonTextColor={bundleButtonTextColor}
      direction={price.symbolPosition === 'Right' ? 'rtl' : 'ltr'}
    >
      <div className="price-underlay">
        <div className="totalPrice">
          {isFree ? (
            <span>{collectText}</span>
          ) : (
            <ActualPrice
              finalPrice={finalPrice}
              priceBeforeDiscount={priceBeforeDiscount}
              price={price}
              textShadow="0px 2px 2px rgba(0, 0, 0, 0.25)"
            />
          )}
        </div>
      </div>
    </StyledBundlePrice>
  );
};
